// extracted by mini-css-extract-plugin
export var chip = "_n1-0";
export var icon = "_n1-1";
export var remove = "_n1-2";
export var removeIcon = "_n1-3";